import React, { useEffect, useState } from 'react';
import Typography from 'kingpin/atoms/Typography';
import FilterPlateContainer from './FilterPlates/FilterPlate';
import { toPlate } from './VariableFiltersSlideOut/VariableFilterCard/VariableFilterCard';
import { Label } from 'components/MyAccount/Profile/styles';
import useDrillDownFieldName from '../hooks/useDrillDownFieldName';
import FilterPlatesProvider from '../contextProviders/FilterPlatesProvider';
import useDataTypesOnReportCanvas from './Report/useDataTypesOnReportCanvas';

export const useVariableFilterDataTypes = (
  variableFilter: VariableDrillDownType,
  canvas: Canvas | undefined,
) => {
  const dataTypesOnCanvas = useDataTypesOnReportCanvas(canvas);
  const [dataTypes, setDataTypes] = useState<string[]>([]);
  useEffect(() => {
    const dataType = variableFilter.value.dataset;
    if (dataType) {
      setDataTypes([dataType]);
    } else {
      setDataTypes(dataTypesOnCanvas);
    }
  }, [dataTypesOnCanvas, variableFilter.value.dataset]);

  return dataTypes;
};

const VariableFilterInput = ({
  variableFilter,
  setVariableFilters,
  canvas,
}: {
  variableFilter: VariableDrillDownType;
  setVariableFilters: React.Dispatch<
    React.SetStateAction<VariableDrillDownType[]>
  >;
  canvas?: Canvas;
}) => {
  const dataTypes = useVariableFilterDataTypes(variableFilter, canvas);
  const fieldName = useDrillDownFieldName(variableFilter.value);
  const onUpdated = (newDrillDown: FixedFilter) => {
    const newVariableFilter = {
      ...variableFilter,
      value: newDrillDown,
    };

    setVariableFilters((vfs) =>
      vfs.map((vs) => {
        if (vs.id === variableFilter.id) {
          return newVariableFilter;
        } else {
          return vs;
        }
      }),
    );
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Label>
        <Typography.Body type={'Label'} color={'var(--color-grey-5)'}>
          {fieldName}
        </Typography.Body>
      </Label>
      <FilterPlatesProvider dataTypes={dataTypes}>
        <FilterPlateContainer
          plate={toPlate(variableFilter)}
          isScope={false}
          isInVariableFilterList
          onUpdated={onUpdated}
        />
      </FilterPlatesProvider>
    </div>
  );
};

export default VariableFilterInput;
